export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_33.b396c418.jpg";